import { render } from "./App.vue?vue&type=template&id=4d5d441a"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4d5d441a&lang=scss"

import exportComponent from "../../../../../../../../Users/whartonjason/WebstormProjects/xike-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__